/**
 * flt_productsreviews — listing entry (→ views/js/flt_reviews-listing.js)
 *
 * Point d'entrée pour les pages de liste produits (catégorie, recherche…).
 * Délègue à l'organisme listing-stars.
 */

import { init } from './organisms/listing-stars';

document.addEventListener('DOMContentLoaded', () => { void init(); });
